(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('Planning', Planning);

    Planning.$inject = ['$resource'];

    function Planning($resource) {

        var baseUrl = 'api/:planType/';
        var id = ':id/';
        var internalVersion = ':internalVersion/';
        var resourceUrl = baseUrl + 'document/' + id + internalVersion;

        return $resource(
            resourceUrl,
            {
                id: '@id',
                planLabel: '@planLabel',
                newPlanLabel: '@newPlanLabel',
                planId: '@planId',
                planType: '@planType',
                parentLabel: '@parentLabel',
                duration: '@duration',
                startTime: '@startTime',
                endTime: '@endTime',
                obsDefLabel: '@obsDefLabel',
                internalVersion: '@internalVersion',
                comment: '@comment',
                eventCollectionsLabel: '@eventCollectionsLabel',
                planProfile: '@planProfile',
                eventSchema: '@eventSchema',
                planLabelToClone : '@planLabelToClone',
                internalVersionToClone : '@internalVersionToClone',
                importLabel : '@importLabel',
                anchorDate : '@anchorDate',
                usernames : '@usernames',
                soopType : '@soopType',
                leadInstrument : '@leadInstrument',
                planLabelToSoopify : '@planLabelToSoopify',
                internalVersionToSoopify : '@internalVersionToSoopify',
                planLabelToUnsoopify : '@planLabelToUnsoopify',
                internalVersionToUnsoopify : '@internalVersionToUnsoopify',
                soopInstanceId : '@soopInstanceId',
                encodedSoopType : '@encodedSoopType',
                soopInstances : '@soopInstances',
                obsInstances : '@obsInstances',
                from: '@from',
                to: '@to',
                efecsVersion: '@efecsVersion',
                prime: '@prime',
                baselineVersion: '@baselineVersion',
                status: '@status',
                dateStart: '@dateStart',
                dateEnd: '@dateEnd'

            },
            {
                'getAllStatusForPlan': {
                    method: 'GET',
                    url: 'api/plan/status-plans',
                    isArray: true
                },
                'getAllLatestPlans': {
                    method: 'GET',
                    isArray: true
                },
                'get': {
                    method: 'GET'
                },
                'delete': {
                    method: 'DELETE'
                },
                'update': {
                    method: 'PUT'
                },
                'create': {
                    method: 'POST',
                    url: baseUrl
                },
                'getAllVersions': {
                    method: 'GET',
                    isArray: true,
                    url: baseUrl + 'all/' + id
                },
                'rename' : {
                    method: 'PUT',
                    url: baseUrl + 'rename'
                },
                'updateObsDef' : {
                    method: 'PUT',
                    url: baseUrl + 'updateObsDef'
                },
                'addObsInstance': {
                    method: 'PUT',
                    url: baseUrl + 'obsInstance/add'
                },
                'deleteObsInstance': {
                    method: 'PUT',
                    url: baseUrl + 'obsInstance/delete'
                },
                'updateObsInstance': {
                    method: 'PUT',
                    url: baseUrl + 'obsInstance/update'
                },
                'bookmark': {
                    method: 'PUT',
                    url: baseUrl + 'bookmark'
                },
                'autoSlews':{
                    method: 'PUT',
                    url: baseUrl + 'autoslews'
                },
                'baseline': {
                    method: 'PUT',
                    url: baseUrl + 'baseline'
                },
                'rollback': {
                    method: 'PUT',
                    url: baseUrl + 'rollback'
                },
                'deleteVersions': {
                    method: 'PUT',
                    url: baseUrl + 'versions-delete'
                },
                'status': {
                    method: 'PUT',
                    url: baseUrl + 'status'
                },
                'lock': {
                    method: 'PUT',
                    url: baseUrl + 'lock'
                },
                'unlock': {
                    method: 'PUT',
                    url: baseUrl + 'unlock'
                },
                'getMeta': {
                    method: 'GET',
                    url: 'api/meta/' + id
                },
                'updateParent': {
                    method: 'PUT',
                    url: baseUrl + 'parent'
                },
                'clone': {
                    method: 'POST',
                    url: baseUrl + 'clone'
                },
                'importPlan': {
                    method: 'PUT',
                    url: baseUrl + 'import-plan'
                },
                'importTemplate': {
                    method: 'PUT',
                    url: baseUrl + 'import-template'
                },
                'importSoop': {
                    method: 'PUT',
                    url: baseUrl + 'import-soop'
                },
                'setUsers': {
                    method: 'PUT',
                    url: baseUrl + 'setUsers'
                },
                'getSoopTypes': {
                    method: 'GET',
                    url: 'api/soop-plan/soop-types',
                    isArray: true
                },
                'soopify' : {
                    method: 'POST',
                    url: 'api/soop-plan/soopify'
                },
                'unsoopify' : {
                    method: 'POST',
                    url: 'api/template-plan/unsoopify'
                },
                'availableSoops' : {
                    method: 'GET',
                    url: 'api/soop-plan/available-soops'
                },
                'soopsInProgress' : {
                    method: 'GET',
                    url: 'api/soop-plan/soops-in-progress'
                },
                'createSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'soop-create'
                },
                'deleteSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'soop-delete'
                },
                'detatchFromSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'remove-soop-instance-ids'
                },
                'autonomizeFromSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'add-dummy-soop-instance-id'
                },
                'addToSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'add-soop-instance-ids'
                },
                'setEfecsVersion' : {
                    method: 'PUT',
                    url: 'api/plan/setEfecsVersion'
                }
            });
    }


})();
